import { ComponentProps } from 'react';
import { Button } from '~/components/common/common';
import { JoinTheme } from '../types/types';

const themeToButtonColor: Record<
  JoinTheme,
  ComponentProps<typeof Button>['btnColor']
> = {
  'blue': 'purple',
  'purple': 'pink',
  'transparent': 'blue',
};

export { themeToButtonColor };
